namespace Shared

open Model
open PortalLibs.Shared.NewTable
open PortalLibs.Shared
open PortalLibs.Shared.Notifications
open System
open Shared.Models


type ContractId = int64
type HeaderId = int64
type ItemId = int64
type JobCostId = int64
type JobCostDetailId = int64
type JobCostAttachmentId = int64
type UserId = System.Guid
type AttachmentId = int64
type VistaAttachmentId = int64
type PurchaseOrderId = { ContractId: int64; Number: string }

type Settings =
  { IsDemo: bool
    IsSuperUser: bool
    CanViewCompanyTab: bool
    ApplicationSettings: ApplicationSettings }

type Query =
  | Wildcard of string
  | Equals of string

type FieldQuery<'T> = { Field: 'T; Query: Query }

type PagedQuery<'T> =
  { Query: FieldQuery<'T> list
    Page: int
    PageSize: int
    Sort: Sort<'T> option
    PageCount: bool
    Totals: 'T list }

type JobCostAttachmentContent =
  | VistaNotAvailable
  | Downloaded

type JobPhase = { Code: string; Desc: string }
type JobPhaseCosts = {
  Phase: JobPhase
  Costs: JobCost list 
}

type RemoteClientMsg =
  | RCBridgeConnected
  | RCAuthed of Settings
  | RCNotAuthedReq
  | RCAuthFailed
  | RCContracts of List<Contract>
  | RCContract of Contract
  | RCPurchaseOrders of ContractId * PurchaseOrder list
  | RCARBuckets of ContractId * ContractARBucket list
  | RCMassPurchaseOrders of (ContractId * PurchaseOrder list) list
  | RCChangeOrdersLoaded of ContractId * ChangeOrderHeader list
  | RCChangeOrderItemsLoaded of HeaderId * ChangeOrderItem list
  | RCChangeOrderLinesLoaded of ItemId * ChangeOrderLine list
  | RCJobHistories of ContractId * JobHistory list
  | RCJobForecasts of ContractId * JobForecast list
  | RCJobSchedule of ContractId * JobSchedule option
  | RCJobCosts of ContractId * JobPhaseCosts list
  | RCContractProfitFade of ContractId * ContractProfitFade option
  | RCContractProfitFades of (ContractId * ContractProfitFade option) list
  | RCContractHomePageBuckets of (ContractId * ContractARBucket) list
  | RCContractProfitFadeAndProfits of ContractId * ContractProfitFade option * ContractProfit list
  | RCContractProfits of ContractId * ContractProfit list
  | RCJobCostSubs of List<JobCostId * JobCostSub list>
  | RCJobCostDetails of JobCostId * JobCostDetail list
  | RCJobCostDetailsCount of JobCostId * int64
  | RCJobCostDetailsTotal of JobCostId * JobCostDetailField * float
  | RCSuperUserContracts of ContractShort list
  | RCContractWithProfitFades of ContractWithProfitFade list
  | RCContractWithProfitFadesCount of int64
  | RCJobCostDetailAttachments of JobCostId * Map<JobCostDetailId, JobCostDetailAttachment list>
  | RCJobCostDetailAttachmentContent of JobCostAttachmentId * JobCostAttachmentContent
  | RCCompanyTabData of List<CompanyTabRow>
  | RCCompanyTabCompanies of List<Company>
  | RCNotification of NotificationMsg

type RemoteServerMsg =
  | RSAuth of UserData * AuthenticationType
  | RSInitializationData
  | RSContractDetails of ContractId
  | RSContractInfo of ContractId
  | RSContractBillingRequested of ContractId
  | RSSendPurchaseOrderRequest of PurchaseOrderRequest
  | RSSuperUserContracts of {| Active: bool |}
  | RSContractWithProfitFades of PagedQuery<ContractWithProfitFadeField>
  | RSContractProfits of ContractId
  | RSJobCostDetails of JobCostId * PagedQuery<JobCostDetailField>
  | RSContractFollowChanged of ContractShort
  | RSContractInterestedPartiesChanged of ContractShort
  | RSJobCostAttachment of JobCostAttachmentId
  | RSContractFollowMassChanged of (ContractId list * bool)
  | RSCompanyTabQuery of (int * DateTime * DateTime) option
  | RSCompanyTabCompanies


module Remote =
  let socketPath = "/socket/appBridge"